var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"margin-right":"25px","align-self":"center","cursor":"pointer"},attrs:{"title":"Dashboard"},on:{"click":function($event){return _vm.goToDashboard()}}},[_c('img',{attrs:{"src":'/static/icons/dashboard.svg',"height":"25"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }